// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Customers from "./pages/Customers";
import Pets from "./pages/Pets";
import Services from "./pages/Services";
import Groomers from "./pages/Groomers";
import Users from "./pages/Users";
import EditProfile from "./pages/EditProfile";
import PrivateRoute from "./components/PrivateRoute";
import { UserProvider } from "./context/UserContext";
import { RefreshProvider } from "./context/RefreshContext";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CustomerDetails from './pages/CustomerDetails'; // Import CustomerDetails
import PetDetails from './pages/PetDetails'; // Import PetDetails
import ServiceDetails from './pages/ServiceDetails';
import GroomerDetails from './pages/GroomerDetails';
import UserDetails from './pages/UserDetails';
import Layout from './components/Layout'; // Import Layout
import Logout from './components/Logout';
import SearchResults from './pages/SearchResults';
import NotificationsPage from "./pages/NotificationsPage";
import ReportsPage from './pages/ReportsPage';
import AdminRoute from './components/AdminRoute';
import ServicesIncomeReport from './pages/ServicesIncomeReport';


function App() {

  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <RefreshProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/logout" element={<Logout />} /> {/* Add Logout Route */}
              {/* Protected Routes */}
              <Route element={<PrivateRoute />}>
                <Route element={<Layout />}>
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/customers/:id" element={<CustomerDetails />} /> {/* Add this route */}
                  <Route path="/pets" element={<Pets />} />
                  <Route path="/pets/:id" element={<PetDetails />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:id" element={<ServiceDetails />} />
                  <Route path="/groomers" element={<AdminRoute><Groomers /></AdminRoute>} />
                  <Route path="/groomers/:id" element={<AdminRoute><GroomerDetails /></AdminRoute>} />
                  <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
                  <Route path="/users/:id" element={<AdminRoute><UserDetails /></AdminRoute>} />
                  <Route path="/reports" element={<AdminRoute><ReportsPage /></AdminRoute>}>
                    {/* <Route index element={<ReportsList />} /> */}
                    <Route path="services-income" element={<AdminRoute><ServicesIncomeReport /></AdminRoute>} />
                  </Route>
                  <Route path="/search" element={<SearchResults />} />
                  <Route path="/edit-profile" element={<EditProfile />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </RefreshProvider>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;